import throwErrorInDev from '../../helpers/throwErrorInDev';
export const TEMP_CART_ID = 'TEMP_CART_ID';
export const getAddToCartOptimisticResponse = (product, quantity = 1, cartId, client, cartQuery) => {
    const defaultOptimisticCart = {
        id: TEMP_CART_ID,
        totalQuantity: quantity,
        __typename: 'Cart',
        externalCheckoutUrl: '',
        productTotal: {
            vat: 0,
            exVat: 0,
            incVat: 0,
            __typename: 'Price'
        },
        productPreviousTotal: {
            vat: 0,
            exVat: 0,
            incVat: 0,
            __typename: 'Price'
        },
        discountTotal: {
            vat: 0,
            exVat: 0,
            incVat: 0,
            __typename: 'Price'
        },
        aggregatedDiscounts: [],
        items: []
    };
    if (cartId) {
        try {
            const { cart } = client.readQuery({
                query: cartQuery,
                variables: { cartId }
            });
            const index = cart.items.findIndex((item) => item.product.id === product.id);
            if (index > -1) {
                const newTotalQuantity = cart.totalQuantity + quantity;
                const newItemQuantity = cart.items[index].quantity + quantity;
                // Already in cart, increase/decrease quantity
                const optimisticCart = Object.assign(Object.assign({}, cart), { totalQuantity: newTotalQuantity, items: [
                        ...cart.items.slice(0, index),
                        ...(newItemQuantity > 0
                            ? [
                                Object.assign(Object.assign({}, cart.items[index]), { quantity: newItemQuantity })
                            ]
                            : []),
                        ...cart.items.slice(index + 1)
                    ] });
                return optimisticCart;
            }
            else {
                const optimisticCart = Object.assign(Object.assign({}, cart), { totalQuantity: cart.totalQuantity + quantity });
                return optimisticCart;
            }
        }
        catch (_a) {
            return defaultOptimisticCart;
        }
    }
    else {
        return defaultOptimisticCart;
    }
};
export const getDecrementQuantityOptimisticResponse = ({ itemId, client, cartId, cartQuery }) => {
    throwErrorInDev(!cartQuery, `You forgot to pass 'cartQuery' to getDecrementQuantityOptimisticResponse`);
    const { cart } = client.readQuery({
        query: cartQuery,
        variables: { cartId }
    });
    const items = cart.items.map((item) => item.id === itemId ? Object.assign(Object.assign({}, item), { quantity: item.quantity - 1 }) : item);
    const optimisticCart = Object.assign(Object.assign({}, cart), { items });
    return optimisticCart;
};
export const getIncrementQuantityOptimisticResponse = ({ itemId, client, cartId, cartQuery }) => {
    throwErrorInDev(!cartQuery, `You forgot to pass 'cartQuery' to getIncrementQuantityOptimisticResponse`);
    const { cart } = client.readQuery({
        query: cartQuery,
        variables: { cartId }
    });
    const items = cart.items.map((item) => item.id === itemId ? Object.assign(Object.assign({}, item), { quantity: item.quantity + 1 }) : item);
    const optimisticCart = Object.assign(Object.assign({}, cart), { items });
    return optimisticCart;
};
export const getRemoveFromCartOptimisticResponse = ({ itemId, client, cartId, setCartId, cartQuery }) => {
    throwErrorInDev(!cartQuery, `You forgot to pass 'cartQuery' to getRemoveFromCartOptimisticResponse`);
    const { cart } = client.readQuery({
        query: cartQuery,
        variables: { cartId }
    });
    const items = cart.items.filter((item) => item.id !== itemId);
    if (items.length === 0) {
        setCartId(null);
    }
    const optimisticCart = Object.assign(Object.assign({}, cart), { items });
    return optimisticCart;
};
export const getSetQuantityOptimisticResponse = ({ itemId, quantity, client, cartId, cartQuery }) => {
    throwErrorInDev(!cartQuery, `You forgot to pass 'cartQuery' to getSetQuantityOptimisticResponse`);
    const { cart } = client.readQuery({
        query: cartQuery,
        variables: { cartId }
    });
    const items = cart.items.map((item) => item.id === itemId ? Object.assign(Object.assign({}, item), { quantity }) : item);
    const optimisticCart = Object.assign(Object.assign({}, cart), { items });
    return optimisticCart;
};
//# sourceMappingURL=cartMutationUtils.js.map